import {GlobalEventService} from "./global-event.service";

export const GlobalEventInjectables: Array<any> = [
  {
    provide: GlobalEventService,
    useClass: GlobalEventService,
  },
];
